module.exports = __webpack_public_path__ + "assets/img/btn-detail-6249d113.png";